/*
 * Application Insights JavaScript SDK - Common, 2.7.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

import { __extendsFn as __extends } from "@microsoft/applicationinsights-shims";
// THIS FILE WAS AUTOGENERATED
import { EventData } from "./EventData";
/**
 * An instance of PageView represents a generic action on a page like a button click. It is also the base type for PageView.
 */
var PageViewData = /** @class */function (_super) {
  __extends(PageViewData, _super);
  function PageViewData() {
    var _this = _super.call(this) || this;
    /**
     * Schema version
     */
    _this.ver = 2;
    /**
     * Collection of custom properties.
     */
    _this.properties = {};
    /**
     * Collection of custom measurements.
     */
    _this.measurements = {};
    return _this;
  }
  return PageViewData;
}(EventData);
export { PageViewData };